import axios from 'axios';
import { store } from './store';
import { logout } from './authSlice';

export const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true
});

// Public routes that don't require auth
const publicRoutes = [
  '/auth/login',
  '/auth/register',
  '/',
  '/about',
  '/pricing'
];

// Add a request interceptor to attach auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const isPublicRoute = publicRoutes.some(route => 
      config.url?.includes(route)
    );

    if (token && !isPublicRoute) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // or wherever you store it
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add a response interceptor to handle refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) { // Check if error.response is defined
      return Promise.reject(error); // If not, reject the promise immediately
    }
    const originalRequest = error.config;
    const isPublicRoute = publicRoutes.some(route => 
      error.config?.url?.includes(route)
    );

    if (error.response.status === 401 && !originalRequest._retry && !isPublicRoute) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const response = await axios.post(`${API_URL}/api/auth/refresh`, { refreshToken });
        const { token } = response.data;
        
        localStorage.setItem('token', token);
        originalRequest.headers.Authorization = `Bearer ${token}`;
        
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        store.dispatch(logout());
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;